import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class DebounceService {
  private debounceTimeout: ReturnType<typeof setTimeout> = null;

  constructor() {
    // This is intentional
  }

  /**
   * Debounce the provided method call
   * @param wait - Time to debounce
   * @param fn - The method to execute
   */
  debounceCall(wait: number, fn: () => void) {
    // Cancel the timeout (for rescheduling afterwards).
    const cancel = () => {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = null;
      }
    };

    // This is a wrapper function which you can invoke multiple times and
    // which will only be called once every "wait" milliseconds.
    const callMethod = () => {
      cancel();
      // eslint-disable-next-line @typescript-eslint/no-implied-eval
      this.debounceTimeout = setTimeout(fn, wait);
    };

    callMethod();
  }
}
